/* ============
 * Vuetify
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://vuetifyjs.com/ko/
 */

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

// vuetify options
const opts = {
    theme: {
        primary: '#3f6fff',
        themes: {
            light: {
                primary: '#3f6fff',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                success: '#4CAF50',
                warning: '#FFC107',
                background: '#FFF',
                alert: '#ea5858',
                //main: '#3f6fff'
                main: '#fff'
            },
        },
    },
}

export default new Vuetify(opts)
